import * as React from "react";
import {
  Form,
  OverlayTrigger, Tooltip
} from "react-bootstrap";
import OutsideClickHandler from "react-outside-click-handler";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import _ from "lodash";
import { FiChevronDown } from "react-icons/fi";

export class DropdownMultiSelect extends React.Component<any, any> {
  private btnSection: any;
  private searchSection: any;

  constructor(props: any) {
    super(props);
    this.btnSection = React.createRef();
    this.searchSection = React.createRef();
    this.state = {
      selectedItems: [],
      filterData: [],
      opened: false,
      itemList: props.data,
      isSelectAll: props.isSelectAll,
      filterTitle: props.filtertitle,
      isSelect: true,
      inputValue: "",
      childClick: false,
    };
  }

  componentDidMount = () => {
    if(this.state.itemList !== undefined) {
      const activeChip = this.state.itemList.filter(
        (itemList: { isChecked: boolean }) => itemList.isChecked === true
      );
      this.setState({
        selectedItems: activeChip,
        filterData: this.state.itemList,
      });
    }
  };

  componentDidUpdate = (prevProps) => {
    const { defaultValue } = this.props;
    if (prevProps?.defaultValue !== defaultValue) {
      let itemList = _.cloneDeep(this.props.data);
      if (!defaultValue) {
        itemList = itemList?.map((x) => {
          x.isChecked = false;
          return x;
        });
        this.handleClearAll();
      }

      const activeChip = itemList.filter(
        (itemList: { isChecked: boolean }) => itemList.isChecked === true
      );

      this.setState({
        selectedItems: activeChip,
        filterData: itemList,
      });
    }
  };
  onChipMouseOver = (): void => {
    this.setState({ childClick: true });
  };
  onChipMouseOut = (): void => {
    this.setState({ childClick: false });
  };
  handleRemoveSpecificChip = (idx: number) => () => {
    this.setState({ childClick: true });
    const { value } = this.props;
    const itemList = [...this.state.itemList];
    const selectedItems = [...this.state.selectedItems];
    const removeSelect = this.getIndex(selectedItems[idx][value], "removeChip");
    itemList[removeSelect].isChecked = false;
    selectedItems.splice(idx, 1);
    this.setState({ selectedItems, itemList });

    const coaSelectedItem = this.state.itemList.filter(
      (itemList: { isChecked: boolean }) => itemList.isChecked === true
    );
    this.props.updateMultiSelectItem(coaSelectedItem);
    this.setState({ childClick: false });
  };

  handleCheckCheckbox = (idx: any) => (event: any) => {
    const { isSelect ,filterData} = this.state;
    const { value, disabled,singleSelectMode  } = this.props;  
    let itemList = [...this.state.itemList];
    const index = itemList.findIndex((xvalue) => xvalue[value] === idx);

    if (disabled && event.target.checked && this.state.selectedItems.length > 0) {
      return; 
    }

    if (singleSelectMode && event.target.checked) {
    itemList = itemList.map(item => ({
      ...item,
      isChecked: false
    }));
    itemList[index].isChecked = true;
  } else {
    itemList[index].isChecked = event.target.checked;
  }
    const selectedItems = itemList.filter((r) => r.isChecked);
    const canSelectMore = itemList.some((o: any) => !o.isChecked);
    this.setState({ selectedItems, itemList, filterData:itemList,isSelect: canSelectMore });
    this.props.updateMultiSelectItem(selectedItems);
  };

  getIndex = (val: any, type: string) => {
    const { value } = this.props;
    if (type === "removeChip") {
      let itemList = [...this.state.itemList];
      return itemList.findIndex((obj) => obj[value] === val);
    } else {
      let selectedItems = [...this.state.selectedItems];
      return selectedItems.findIndex((obj) => obj[value] === val);
    }
  };

  handleChange = (e: { target: { value: string } }) => {
    const value = e.target.value;
    this.setState({ filterData: [] }, () => {
      const updatedList = this.state.itemList.filter((item) => {
        return (
          item[this.props.label]
            ?.toString()
            ?.toLowerCase()
            ?.indexOf(value?.toLowerCase()) > -1
        );
      });
    
      this.setState({
        filterData: updatedList,
        inputValue: value
      });
    });
  };
  
  updateSavedItem = (data: any) => {
    const { value } = this.props;
    let allCoaList = [...this.state.itemList];

    allCoaList.forEach((element) => {
      element.isChecked = false;
    });

    this.setState({ itemList: allCoaList });
    data.forEach((element: { value: any }) => {
      const item = this.state.itemList.find(
        (itemList: { value: any }) => itemList[value] === element[value]
      );

      if (item) {
        item.isChecked = true;
      }
    });
    this.setState({ selectedItems: data });
  };

  handleClick = () => {
    if (this.state?.childClick === true) {
      return false;
    }

    this.setState((prevState) => ({
      opened: !prevState.opened,
    }));

    this.setState({
      filterData: this.state.itemList,
    });
    this.setState({ inputValue: "" });
  };

  handleOutsideClick = (e) => {
    this.setState((prevState) => ({
      opened: false,
    }));
    this.setState({ inputValue: "" });
  };

  handleSelectAll = (e: any) => {
    let allItemList = [...this.state.itemList];
    allItemList.map((element) => {
      if (
        this.state.filterData.filter((x) => x.jobid === element.jobid)
          .length > 0
      ) {
        element.isChecked = true;
      }
      return element;
    });
    this.setState({ itemList: allItemList, isSelect: false, opened: false });
    this.setState({ selectedItems: allItemList?.filter((x) => x.isChecked) });
    this.props.updateMultiSelectItem(allItemList?.filter((x) => x.isChecked));
  };

  handleClearAll = () => {
    let allItemList = [...this.state.itemList];
    allItemList.forEach((element) => {
      element.isChecked = false;
    });
    this.setState({ itemList: allItemList, isSelect: true });
    this.setState({ selectedItems: [] });
    this.props.updateMultiSelectItem([]);
  };

  render() {
    const { label, value, disabled , name} = this.props;
   
    const renderTooltip = (props) => {
      if (!this.state.selectedItems || this.state.selectedItems.length === 0) {
        return (
          <></>
        );
      }

      const minItemsToShow = name == "JO" ? 2 : 4;
      if (this.state.selectedItems.length < minItemsToShow){
        return (
          <></>
        );
      }
    
      return (
        <Tooltip id="selectedItemsTooltip" {...props}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
          {this.state.selectedItems.map((item, idx) => (
            <div key={idx} style={{ display: 'inline-block',fontSize: '12px' }}>
              {item[`${name === "JO" ? value : label}`]}
            </div>
          ))}
        </div>
      </Tooltip>
      );
    };

  
  
    return (
      <OutsideClickHandler onOutsideClick={this.handleOutsideClick}>
        <OverlayTrigger
          placement="bottom"
          overlay={renderTooltip}
        >
        <div
          className={
            this.state.opened
              ? "multiSelectSearch aca-codes opened"
              : "multiSelectSearch aca-codes"
          }
        >
          <div
            className="fieldArea"
            onMouseOut={this.onChipMouseOut}
            onClick={this.handleClick}
          >
            {this.state.selectedItems.length === 0 ? (
              <span className="areaPlaceholder">
                {this.props?.placeHolder}
                <FiChevronDown style={{ marginLeft: 'auto' }} />
              </span>
            ) : (
              <div className="chip" onMouseOut={this.onChipMouseOut} >
  
                {this.state.selectedItems.map((item: any, idx: any) => (
                  idx > 2 ? (idx > 3 ? "" : "…") :
                  <div
                    onMouseOver={this.onChipMouseOver}
                    className="chipSelect"
                    id={idx}
                    key={idx}
                  >
                    <div className="chipVal">
                      {
                        name === "JO" ? item[value] : name === "Loc"? (item[label]?.match(/\(([^)]+)\)/)?.[1] || item[label]) : item[label]
                      }
                      </div>
                    <button
                      id="btnremove"
                      type="button"
                      className="cross"
                      onMouseOver={this.onChipMouseOver}
                      onClick={this.handleRemoveSpecificChip(idx)}
                    >
                      <svg
                        width="8"
                        height="8"
                        viewBox="0 0 8 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6.79465 0.229492L3.96598 3.05749L1.13798 0.229492L0.195312 1.17216L3.02331 4.00016L0.195312 6.82816L1.13798 7.77083L3.96598 4.94282L6.79465 7.77083L7.73731 6.82816L4.90931 4.00016L7.73731 1.17216L6.79465 0.229492Z"
                          fill="#6A6E73"
                        />
                      </svg>
                    </button>
                  </div>
                ))}
                
            
                {this.state.selectedItems.length > 0 && (
                <span className="p-1" style={{cursor: "pointer",color: "#28a745",fontSize: "25px"}} >+</span>)}
                </div>)}

            <div
              className="coaSearch"
              onMouseOver={this.onChipMouseOver}
              ref={(searchSection) => {
                this.searchSection = searchSection;
              }}
            >
              <div className="dropDownPanel">
                <div className="SearchInput">
                  <input
                    key={"text-Filter"}
                    type="text"
                    className="form-control"
                    onChange={this.handleChange}
                    placeholder={this.props?.filtertitle}
                    value={this.state.inputValue}
                  />
                </div>
                <ul>      
                  {this.state.filterData.map((item: any, idx: any) => (
                    <li id={item[value]} key={item[value]}>
                      <Form.Check
                        type="checkbox"
                        key={"custom-s" + item[label]}
                        id={"custom-s" + item[label]}
                        label={<EllipsisWithTooltip placement="bottom">{item[label]}</EllipsisWithTooltip>}
                        checked={item.isChecked}
                        onChange={this.handleCheckCheckbox(item[value])}
                        disabled={disabled && this.state.selectedItems.length > 0 && !item.isChecked} 
                      />
                    </li>
                  ))}
                </ul>
                {this.state.isSelectAll && this.state.filterData?.length > 0 && (
                  <div className="footer">
                    {this.state.isSelect && (
                      <button
                        id="selectAll"
                        type="button"
                        className="btn wht-bg txt-green"
                        onClick={this.handleSelectAll}
                      >
                        Select All
                      </button>
                    )}
                    {!this.state.isSelect && this.state.filterData?.length > 0 && (
                      <button
                        id="ClearAll"
                        type="button"
                        className="btn wht-bg txt-green"
                        onClick={this.handleClearAll}
                      >
                        Clear All
                      </button>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        </OverlayTrigger>
      </OutsideClickHandler>
    );
  }
}
